import QrTab from "./qrTab.container";

export default QrTab;